/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
// eslint-disable-next-line lodash-fp/use-fp, lodash-fp/consistent-name
import { find } from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Menu from '../../components/Menu'
import config from '../../config/app'
import * as actionCreators from '../../root/actions'
import { dispatch } from '../../root/store'

export class Nav extends Component {
  UNSAFE_componentWillMount() {
    const { sortNav } = this.props
    sortNav(config.nav)
  }

  calculateSurveyProgress(activeAssessments) {
    let assessmentProgress = 0
    for (const key in activeAssessments) {
      if (key !== 'consent') {
        if (activeAssessments[key].completed) ++assessmentProgress
      }
    }
    return assessmentProgress
  }

  render() {
    const { nav, app } = this.props.containers
    const { location } = this.props.router
    const action = this.props.changeRoute
    const activeTopMenuItem = nav.get('activeTopMenuItem')
    const activeMenuIndex = nav.get('activeMenuIndex')
    const isMenuToggled = nav.get('isMenuToggled')
    const highlightedNavbarSection = nav.get('highlightedNavbarSection')
    const items = nav.get('sortedNav')
    const isSurveysDone =
      app.get('activeAssessments') &&
      find(app.get('activeAssessments'), {
        completed: false
      }) === undefined

    let isOldVisit = true
    if (app.get('activeVisit') !== null) {
      const uuid = app.get('activeVisit').uuid
      const hasVisitPassed = find(app.get('history'), { uuid })
      if (hasVisitPassed === undefined) isOldVisit = false
    }

    const menuProps = {
      action,
      highlightedNavbarSection,
      activeTopMenuItem,
      activeMenuIndex,
      isMenuToggled,
      dispatch,
      items,
      location,
      isSurveysDone,
      isOldVisit
    }

    return <Menu {...menuProps} />
  }
}

const mapStateToProps = state => {
  const { containers, router } = state

  return {
    containers,
    router
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nav)
